import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Success = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(3);
  let countInterval = null;

  useEffect(() => {
    countInterval = setInterval(() => setCounter((prev) => prev - 1), 1000);

    return () => {
      if (countInterval) clearInterval(countInterval);
    };
  }, []);

  useEffect(() => {
    if (counter === 0) {
      navigate("/myspace/schedule");
      clearInterval(countInterval);
    }
  }, [counter]);

  return (
    <div>
      <h1>Your payment is successful!</h1>
      <p>Redirecting in {counter} seconds</p>
    </div>
  );
};

export default Success;
